import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Container } from 'reactstrap';
import onboarding from 'src/assets/dashboard/onboarding.png';
import { Svg } from '../shared/Svg';

interface IOnboardingProps {
  type: string;
  toggleProjectModal: () => void;
}

export const Onboarding: React.SFC<IOnboardingProps> = ({
  type,
  toggleProjectModal,
}) => (
  <Container className='d-flex flex-column justify-content-around align-items-center p-5'>
    {type === 'client' ? (
      <>
        <h2 className='text-primary'>Une idée, un project ?</h2>
        <span
          className='text-primary'
          style={{ fontSize: '18px', fontFamily: 'Fredoka One' }}
        >
          Nos experts sont{' '}
          <strong className='text-warning'>à portée de clic ;)</strong>
        </span>
      </>
    ) : (
      <>
        <h2 className='text-primary'>
          Patience, nos équipes sont à pied d'oeuvre !
        </h2>
        <span
          className='text-primary'
          style={{ fontSize: '18px', fontFamily: 'Fredoka One' }}
        >
          Est-ce que votre profil{' '}
          <strong className='text-warning'>est bien complet et à jour ?</strong>
        </span>
      </>
    )}
    <img className='m-5' width={512} src={onboarding} />
    {type === 'client' ? (
      <Button
        className='d-flex align-items-center text-white bg-primary m-2 border-0'
        onClick={toggleProjectModal}
      >
        <Svg width={48} fill='white' src='plus' className='mr-2' />
        <span>
          Nouveau
          <br />
          projet
        </span>
      </Button>
    ) : (
      <Link to='/profile/'>
        <Button className='text-white bg-primary border-0'>
          Mettre à jour mon profil
        </Button>
      </Link>
    )}
  </Container>
);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Onboarding.tsx